module.exports = __webpack_public_path__ + "img/c5a1013598e67b0518d11747c236d871.png";